import React from 'react';
import { styled, Typography } from '@mui/material';
import { getThemeColors } from '../helpers/themeStyles';

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  fontWeight: 900,
  color: getThemeColors(theme).logo,
  letterSpacing: 0.1,
}));

const DrivioLogo = ({ sx, className }) => (
  <StyledTypography sx={sx} className={className}>
    DRIVIO
  </StyledTypography>
);

export default DrivioLogo;
